import type { ReactNode } from "react";
import HomePage from "../pages/Home";
import SchedulePage from "../pages/Schedule";
import DeadlinesPage from "../pages/Deadlines";
import MapPage from "../pages/Map";
import SettingsPage from "../pages/Settings";

export type Route = "/" | "/schedule" | "/deadlines" | "/map" | "/settings";

export function normalizePath(p: string): Route {
  if (p.length > 1 && p.endsWith("/")) p = p.slice(0, -1);
  if (p === "" || p === "/") return "/";
  if (p === "/schedule") return "/schedule";
  if (p === "/deadlines") return "/deadlines";
  if (p === "/map") return "/map";
  if (p === "/settings") return "/settings";
  return "/";
}

export function getPageComponent(path: Route): ReactNode {
  switch (path) {
    case "/":
      return <HomePage />;
    case "/schedule":
      return <SchedulePage />;
    case "/deadlines":
      return <DeadlinesPage />;
    case "/map":
      return <MapPage />;
    case "/settings":
      return <SettingsPage />;
    default:
      return (
        <div className="page">
          <h2>404</h2>
          <div className="muted">Page not found: {path}</div>
        </div>
      );
  }
}

export function navigate(path: string) {
  const target = new URL(path, window.location.origin);
  const next = `${target.pathname}${target.search}${target.hash}`;
  const current = `${window.location.pathname}${window.location.search}${window.location.hash}`;
  if (current === next) return;
  window.history.pushState({}, "", next);
  window.dispatchEvent(new Event("app:navigate"));
}

